module.exports = __webpack_public_path__ + "static/media/04-galeria-02-perisur@2x.97cd0617.jpg";